export enum RegisterStep {
  REGISTER = 'register',
  COMPLETE_REGISTRATION = 'complete-registration',
  EXISTING_ACCOUNT = 'existing-account',
}
